import http from '../http'

export class UserDataController {
    #apiUrl
    #tc
    #userRoles

    constructor (from, userId) {
        this.#apiUrl = `${from}/v1/users/${userId}`
    }

    async fetchFromAPi () {
        try {
            // Authenticated by the BFF via the shared session cookie (no Token header).
            const response = await http.get(this.#apiUrl)
            this.#tc = response.data.tc_kimlik_number
            this.#userRoles = response.data.auth_role
        } catch (error) {
            console.log('error', error)
        }
    }

    getTc () {
        return this.#tc
    }

    getUserRoles () {
        return this.#userRoles
    }
}
